
var _id = 0

export const getId = () => {
    _id--
    return 'el' + _id
}